"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TinyButton = TinyButton;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

function TinyButton({
  children,
  disabled,
  testId,
  type = 'button',
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledButton, _extends({
    "data-testid": testId,
    disabled: disabled,
    type: type
  }, props), children);
}